import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "limit-exception__form" }
const _hoisted_2 = { class: "limit-exception__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutocompleteSelect = _resolveComponent("AutocompleteSelect")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref: "LimitExceptionFormRef",
    model: _ctx.exceptionLimitItem,
    rules: _ctx.limitExceptionSettingsFormRules
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form_item, {
          label: "User tags",
          prop: "playerTags"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AutocompleteSelect, {
              modelValue: _ctx.exceptionLimitItem.playerTags,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.exceptionLimitItem.playerTags) = $event)),
              options: _ctx.tagOptionListByCurrency,
              "is-loading": _ctx.isTagListLoading,
              class: "limit-exception__form-tag-select",
              "label-key": "name",
              "value-key": "id",
              "is-multiple": "",
              "collapse-tags": true,
              "collapse-tags-tooltip": true,
              placeholder: "Select tag",
              "remote-method": _ctx.getSearchTagList,
              onClearSearchResult: _ctx.clearAutocompleteTagListSearchResult
            }, null, 8 /* PROPS */, ["modelValue", "options", "is-loading", "remote-method", "onClearSearchResult"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_form_item, {
          label: "Deposit limit",
          prop: "min"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              "model-value": _ctx.exceptionLimitItem.min,
              inputmode: "decimal",
              class: "limit-exception__form-input",
              placeholder: "min",
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.roundLimitField('min'))),
              "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => _ctx.updateLimitField('min', value))
            }, null, 8 /* PROPS */, ["model-value"])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_form_item, { prop: "max" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              "model-value": _ctx.exceptionLimitItem.max,
              inputmode: "decimal",
              class: "limit-exception__form-input",
              placeholder: "max",
              onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.roundLimitField('max'))),
              "onUpdate:modelValue": _cache[4] || (_cache[4] = (value) => _ctx.updateLimitField('max', value))
            }, null, 8 /* PROPS */, ["model-value"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.isUpdateLimitExceptionButtonAllowed)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "success",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSaveLimitException(_ctx.exceptionLimitItem.id)))
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Save ", -1 /* CACHED */)
              ]))]),
              _: 1 /* STABLE */
            }))
          : _createCommentVNode("v-if", true),
        (_ctx.isDeleteLimitExceptionButtonAvailable)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "danger",
              icon: _ctx.icons.Delete,
              round: "",
              plain: "",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.deletePaymentMethodExceptionLimit(_ctx.exceptionLimitItem.id)))
            }, null, 8 /* PROPS */, ["icon"]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["model", "rules"]))
}